import { Button } from '@shared/components/ui/button'
import { usePageTitle } from '@shared/hooks/usePageTitle'
import { roleLabel } from '@shared/lib/roles/roles'
import { Link } from 'react-router'
import { useAuthStore } from '../hooks/useAuthStore'

const AREA_OWNER = { manager: 'Gestores e Administradores', admin: 'Administradores' } as const

/** Substitui o redirecionamento silencioso: explica o porquê e leva a pessoa de volta ao início. */
export function AccessDenied({ required }: { required: keyof typeof AREA_OWNER }) {
  usePageTitle()
  const role = roleLabel(useAuthStore((state) => state.user?.role))
  return (
    <section
      aria-labelledby="access-denied-title"
      className="mx-auto max-w-xl space-y-4 rounded-2xl border bg-card p-8 text-center"
    >
      <h1 id="access-denied-title" className="text-2xl font-semibold">
        Esta área não está disponível para você
      </h1>
      <p className="text-base">
        Esta área é só para {AREA_OWNER[required]}.{role ? ` Você entrou como ${role}.` : ''}
      </p>
      <p className="text-base text-muted-foreground">
        Se você precisa dela para o seu trabalho, peça acesso à pessoa responsável pelo Verbum na
        sua empresa.
      </p>
      <Button asChild size="lg">
        <Link to="/dashboard">Voltar ao início</Link>
      </Button>
    </section>
  )
}
